export const SET_CATALOG_ITEMS = 'SET_CATALOG_ITEMS';
export const SET_IS_LOADING_CATALOG = 'SET_IS_LOADING_CATALOG';
export const ADD_TO_SALES_MATCHING_TO_UPDATE = 'ADD_TO_SALES_MATCHING_TO_UPDATE';
export const SET_SALES_MATCHING_TO_UPDATE_BODY = 'SET_SALES_MATCHING_TO_UPDATE_BODY';
export const SET_IS_LOADING_ADD_TO_SALES_MATCHING_TO_UPDATE = 'SET_IS_LOADING_ADD_TO_SALES_MATCHING_TO_UPDATE';
export const SET_IS_LOADING_UPDATE_REFERENCES = 'SET_IS_LOADING_UPDATE_REFERENCES';
export const SET_COLUMNS_ORDER = 'SET_COLUMNS_ORDER';
export const SET_SALES_MATCHING_ITEMS_SELECTED = 'SET_SALES_MATCHING_ITEMS_SELECTED';
export const SET_IS_LOADING_OWN_CLIENT_PRODUCT = 'SET_IS_LOADING_OWN_CLIENT_PRODUCT';
export const SET_IS_LOADING_UNMATCH_SALES = 'SET_IS_LOADING_UNMATCH_SALES';
export const SET_OPTIONS = 'SET_OPTIONS';
